import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { CreateNpsSubmission } from '@/Network/Types/Requests/NpsRequests'

export default class NpsSubmissionService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/submissions'
  }

  async create(payload: CreateNpsSubmission): Promise<{ id: number }> {
    const response = await request.post<{ id: number }>(this.getCompletePath(), payload)
    return response.data
  }
}
